import { useSelector } from 'react-redux'

import { selectReasonsForNotCompletedOrders } from '@/features/domain/territory'

import { useDynamicLoadsCfData } from '../../hooks/useDynamicLoadsCfData'
import { DriverActivityForm } from './DriverActivityForm'
import { useCollectStartEndRoute } from './hooks/useCollectStartEndRoute'
import { DriverActivityFormValues } from './types'

export function DriverActivityFormProvider() {
  // Get reasons for orders from the domain state and the update method
  const reasonsForNotCompletedOrders = useSelector(selectReasonsForNotCompletedOrders)

  const collectStartEndRoute = useCollectStartEndRoute()
  const { enableDynamicCustomFields, enableDynamicLoads } = useDynamicLoadsCfData()

  const initialValues: DriverActivityFormValues = {
    reasonsForNotCompletedOrders,
    collectStartEndRoute,
    enableDynamicCustomFields,
    enableDynamicLoads,
  }

  return <DriverActivityForm initialValues={initialValues} />
}
